// src/modules/app-views/products/pages/Document/components/CardHeaderProductTags.jsx
// *******************************************************************************
// PRODUCT CARD HEADER TAGS
// *******************************************************************************
// Displays: origin (NACIONAL/IMPORTADO), purpose (REVENDA/CONSUMO/etc),
// and tracking (SERIAL/LOTE) when not 'none'.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag, Tooltip } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CardHeaderProductTags = ({ data: dataProp }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const data = dataProp || {};
  const isNew = !data?._id || data?._id === 'add';
  if (isNew) return null;

  const icmsOrigin = data?.fiscalData?.icms?.origin;
  const purpose = data?.stock?.purpose || 'resale';
  const tracking = data?.stock?.tracking || 'none';
  const isUnique = data?.stock?.isUnique === true;

  // Origin: 0 = national, 1-2 = imported, 6-7 = imported (sem similar)
  const isImported = icmsOrigin === 1 || icmsOrigin === 2 || icmsOrigin === 6 || icmsOrigin === 7;

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      {/* Origin Tag */}
      {icmsOrigin != null && (
        <Tooltip title={translateX('icms_origin')}>
          <Tag color={isImported ? 'orange' : 'blue'} style={{ margin: 0 }}>
            {isImported ? translateX('imported') : translateX('national')}
          </Tag>
        </Tooltip>
      )}

      {/* Purpose Tag */}
      <Tooltip title={translateX('product_purpose')}>
        <Tag color={getPurposeColor(purpose)} style={{ margin: 0 }}>
          {translateX(`purpose_${purpose}`)}
        </Tag>
      </Tooltip>

      {/* Tracking Tag (only when not 'none') */}
      {tracking !== 'none' && (
        <Tooltip title={translateX('tracking')}>
          <Tag color={tracking === 'serial' ? 'volcano' : 'geekblue'} style={{ margin: 0 }}>
            {isUnique ? translateX('unique_item') : translateX(`tracking_${tracking}`)}
          </Tag>
        </Tooltip>
      )}
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderProductTags;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function getPurposeColor(purpose) {
  const colors = {
    resale: 'green',
    raw_material: 'orange',
    semi_finished: 'gold',
    finished_goods: 'blue',
    consumption: 'purple',
    packaging: 'default',
    assembly_part: 'cyan',
    digital: 'magenta',
  };
  return colors[purpose] || 'default';
}
